Apt.fn.make('account.listing.preview', {
	/**
	 * Initialize module
	 */
	init() {
		const scope = this;

		LS.util.load([
			'directory',
			'property',
			'property-render'
		], () => {
			LS.api.get('me/listings/' + $.context('id') + '/preview', {
				auth: true,
				namespace: 'listing.preview',
				success: data => {
					document.title = data.title + ' - LandSearch';

					scope.$private.render(data);
				}
			});
		});
	},

	/**
	 * Unload module
	 */
	unload() {
		LS.util.reset('listing.preview');

		Apt.property.unload();
	}
}, {
	/**
	 * Render preview
	 *
	 * @param {Object} data
	 */
	render(data) {
		const views = [
			'_cover',
			'_thumbs',
			'entry'
		];

		let pending = views.length;

		views.forEach(view => {
			LS.util.view('property', view, template => {
				pending--;

				$.view.addView('property.' + view, template);

				if (! pending) {
					LS.property.transform(data);

					$$('preview').html(
						$.view.render('property.entry', data)
					)
						.removeClass('g-loading');

					$.set('context', LS.property.context(data));

					Apt.property.init();
				}
			});
		});
	}
});